import { FC, useContext, useState } from "react";
import NotificationDispatch, {
  showErrorNotification,
  showSuccessNotification,
} from "../../../context/notificationContext";
import { useI18n } from "../../../hooks/useTranslations";
import { useCostTypesApi } from "../../../http/costTypes/api";
import { UpsertCostType } from "../../../http/costTypes/types";
import SvgAdd from "../../icons/Add";
import Button from "../../ui/Button";
import ModalDialog from "../../ui/ModalDialog";
import CostTypeForm, { CostTypeFormBody } from "./CostTypeForm";

const CreateCostTypeButton: FC = () => {
  const i18n = useI18n();
  const [show, setShow] = useState(false);
  const dispatch = useContext(NotificationDispatch);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const costTypesApi = useCostTypesApi();

  const onSubmit = async (formData: CostTypeFormBody) => {
    const body: UpsertCostType = {
      categoryId: formData.category.id,
      name: formData.name,
      dkvProductCodes: formData.dkvProductCodes,
      pkwAccountingNumber: formData.pkwAccountingNumber,
      lkwAccountingNumber: formData.lkwAccountingNumber,
      pkwSuperiorAccountingNumber: formData.pkwSuperiorAccountingNumber,
      costObject: formData.costObject,
    };

    setIsSubmitting(true);
    try {
      await costTypesApi.insertAdminCostType(body);
      dispatch(showSuccessNotification(i18n.t));
      setShow(false);
    } catch (error) {
      dispatch(showErrorNotification(i18n, error));
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <>
      <Button buttonProps={{ onClick: () => setShow(true) }} glyph={SvgAdd} />
      {!!show && (
        <ModalDialog onClose={() => setShow(false)} title={i18n.t.costTypes.new}>
          <CostTypeForm isDisabled={isSubmitting} onSubmit={onSubmit} />
        </ModalDialog>
      )}
    </>
  );
};

export default CreateCostTypeButton;
